"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiTabView = void 0;
const react_1 = require("react");
const React = require("react");
const tab_1 = require("./tab");
require("./tab-view.less");
function isUiTab(value) {
    return value && value.type && value.type === tab_1.UiTab;
}
class UiTabView extends react_1.Component {
    render() {
        const { children } = this.props;
        const content = Array.isArray(children) ? children : [];
        return (React.createElement("div", { className: "ui-tab-view" },
            React.createElement("div", { className: "ui-tab-view__tabs" }, children),
            React.createElement("div", { className: "ui-tab-view__content" }, content.map(c => isUiTab(c) && c.props.active && c.props.children))));
    }
}
exports.UiTabView = UiTabView;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/tab-view/tab-view.tsx
// module id = 2706
// module chunks = 0 1